import { Grid, Tooltip, Box } from '@mui/material';
import { FC, useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { ExtendedGridColDef } from '@/types/ExtendedGridColDef';
import { SCUICustomDataGrid } from '../../../../atomic/molecules';
import { CustomerQuery } from '../../../../services/query';
import TimeHelper from '../../../../utils/time';
import { SCUILoadingLinear } from '../../../../atomic/atoms';
import { CCM } from './customerContactMessage.classes';
interface IProps {
    datas?: any;
}

export const CustomerContactMessage: FC<IProps> = ({ datas }) => {
    const { t } = useTranslation();
    const [messageList, setMessageList] = useState<any>([]);
    const [loading, setLoading] = useState(false);
    enum SubjectStatus {
        'Üyelik' = 1,
        'Siparişlerim',
        'Kampanyalar',
        'İade',
        'Ödemeler',
        'Teknik',
        'Kurumsal',
        'Diğer',
        'Cüzdan İadesi',
        'Kargo Fiyatı',
    }
    enum DescriptionStatusEnum {
        'bo_Unread' = 1,
        'bo_Read',
        'bo_Answered',
        'bo_NotAboutOnlineSales',
        'bo_WaitingAnswerefFromCenter',
    }
    const columns: ExtendedGridColDef[] = [
        { field: 'messageNo', headerName: t('general.messageNo'), flex: 1 },
        {
            field: 'message',
            headerName: t('general.message'),
            flex: 1,
            renderCell: (params: any) => {
                return (
                    <div>
                        <Tooltip title={<h2>{params.row.message}</h2>}>
                            <p>{params.row.message}</p>
                        </Tooltip>
                    </div>
                );
            },
        },
        { field: 'orderNo', headerName: t('general.orderNo'), flex: 1 },
        { field: 'subject', headerName: t('general.subject'), flex: 1 },
        { field: 'date', headerName: t('general.date'), flex: 1 },
        {
            field: 'status',
            headerName: t('general.status'),
            flex: 1,
            renderCell: (params: any) => {
                return <div>{t(`customerContactMessage.${params.row.status}`)}</div>;
            },
        },
        {
            field: 'detay',
            headerName: t('general.detail'),
            flex: 1,
            align: 'center',
            headerAlign: 'center',
            hide: true,
            renderCell: () => {
                return <div className="cursorPointer">{t('general.show')}</div>;
            },
        },
    ];

    const GetCustomerContactMessageList = async () => {
        setLoading(true);
        CustomerQuery.GetCustomerContactMessageList(datas.customer.customerId)
            .then((res: any) => {
                if (res.data) {
                    console.info(res.data);
                    let parseData = res.data.map((item: any) => {
                        return {
                            //date: TimeHelper.formatDate(item.operationDate) || "-",
                            messageNo: item.messageID || '-',
                            message: item.messageText || '-',
                            orderNo: item.orderNo || '-',
                            subject: SubjectStatus[item.subjectId] || '-',
                            date: TimeHelper.formatDateHourSecond(item.date) || '-',
                            change: item.operatorId || '-',
                            status: DescriptionStatusEnum[item.statusId] || '',
                        };
                    });
                    setMessageList(parseData);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        GetCustomerContactMessageList();
    }, []);
    return (
        <Grid container className={CCM.page}>
            <SCUILoadingLinear display={loading} />
            <Grid
                className={CCM.gridInner}
                sx={{ marginLeft: '1rem' }}
                size={{
                    xl: 12,
                    lg: 12,
                    md: 12,
                    xs: 12,
                }}
            >
                <Box className={CCM.datagrid}>
                    <SCUICustomDataGrid randomId rows={messageList} columns={columns} />
                </Box>
            </Grid>
        </Grid>
    );
};
